
import {deepClone} from "./deepClone.js"
export default {
  data() {
    return {
      /// 房源特性扩展
      bit_houseFeature: {
          //优质
          DB_HIGH_QUALITY :             1,
          //主推
          DB_PRIORITY :                 1 << 1,
          //有图片
          DB_HAVE_PICTURE :             1 << 2,
          //vr
          DB_HAVE_VR :                  1 << 3,
          //有钥匙
          DB_HAVE_KEYS :                1 << 4,
          //限售
          DB_LIMIT_SALE :               1 << 5,
          //已迁出
          DB_HUKOU_MOVED :              1 << 6,
          //独家
          DB_ENTRUST_EXCLUSIVE :        1 << 7,
          // 有无储藏库
          STORAGE_BICYCLE :             1 << 8,
          // 是否可做餐饮
          DB_REPAST :                   1 << 9,
          // 是否有下水道
          DB_HAVE_SEWERSTATUS :         1 << 10,
          // 是否有烟道
          DB_HAVE_FLUESTATUS :          1 << 11,
          // 是否可分割面积
          DB_AREASEGMENTASTATUS :       1 << 12,
          // 是否有公共卫生间
          DB_HAVE_PUBLICTOILE :         1 << 13,
          // 是否有独立卫生间
          DB_HAVE_SPEARATETOILE :       1 << 14,
          // 是否有空调
          DB_HAVE_CONDITIONER :         1 << 15,
          // 是否有电梯
          DB_HAVE_ELEVATOR :            1 << 16,
          // 是否有床
          DB_HAVE_BED :                 1 << 17,
          // 是否有柜子
          DB_HAVE_CABINET :             1 << 18,
          // 是否有窗帘
          DB_HAVE_CURTAIN :             1 << 19,
          // 是否有电视
          DB_HAVE_TV :                  1 << 20,
          // 是否有冰箱
          DB_HAVE_ICEBOX :              1 << 21,
          // 是否有宽带
          DB_HAVE_NETWORK :             1 << 22,
          // 是否有热水器
          DB_HAVE_WATER_HEATER :        1 << 23,
          // 是否有洗衣机
          DB_HAVE_WASHING_MACHINE :     1 << 24,
          // 是否急售
          DB_URGENT_SALE :              1 << 25,
          // 是否合租
          DB_SHARE_RENT :               1 << 26,
          // 是否天然气
          DB_HAVE_NATURAL_GAS:				  1 << 27,
          // 是否暖气
          DB_HAVE_HEATING: 				      1 << 28,
      },
      /// 查询扩展
      queryFeature: {
        limit_180 :                     1,
        parking :                       1 << 1,
        QUERY_LIMIT_RENT_30:            2 << 2,
      },
    }
  },


  /// 生成十进制的房源特性
  genarateHouseFeature(obj) {

    var resultDecimal = 0
    for (let key in obj) {
      if (obj[key]) {
        let value = this.data().bit_houseFeature[key]
        resultDecimal = resultDecimal | value
      }
    }
    return resultDecimal
  },

  /// 从十进制获取房源特性
  dealHouseFeature(decimal) {
    var newResult = deepClone(this.data().bit_houseFeature);
    for (let key in this.data().bit_houseFeature) {
      let value = this.data().bit_houseFeature[key]
      newResult[key] = (decimal & value) == value
    }
    return newResult
  },

  /// 生成查询扩展十进制
  generateQueryFeature(item) {
    return parseInt(item,2)
  }
}
